import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import {
  useEditCounsellingTypeMutation,
  useEditDevelopmentTypeMutation,
  useSingelCounsellingTypeQuery,
  useSingelDevelopmentPlanQuery
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormTemplate
} from "../../../../Components/Forms/InputTemplate";
const EditDevelopmentTypeModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  id,
  onValidate = () => {},
}) => {

  const { data } = useSingelDevelopmentPlanQuery(id);
  const formMethods = useForm({
    defaultValues: {
      title: "",
    },
    mode: "all",
  });
  React.useEffect(() => {
    if (data?.responseObject) {
      formMethods.reset({
        title: data.responseObject.title || "",
      });
    }
  }, [data, formMethods]);
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;
  const [onCreate] = useEditDevelopmentTypeMutation();
  const submit = async (data) => {
    const payload = {
      id,
      title: data.title,
    };
    try {
      const response = await onCreate(payload).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Edit</h4>
          <h1 className="text-[28px] font-[800]">Counselling Type </h1>
          <p>
            Helps the system suggest appropriate actions based on performances
            score
          </p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormInput
                title={"Title"}
                camelCase={"title"}
                placeholder={"select"}
              />
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  type={"submit"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Edit Development Type
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditDevelopmentTypeModal;
